import { render } from "./Faturamento.vue?vue&type=template&id=2e126a2a"
import script from "./Faturamento.vue?vue&type=script&lang=ts"
export * from "./Faturamento.vue?vue&type=script&lang=ts"
script.render = render

export default script